import { useEffect, useContext, useState, memo } from "react"
import { ThemeContext } from "../../softphone/themes"

import IconBed from "./default/icon-bed.svg?url"
import IconBath from "./default/icon-bath.svg?url"
import IconLotSize from "./default/icon-lot-size.svg?url"
import IconSQFT from "./default/icon-sqft.svg?url"
import DialerCloseAIIcon from "./default/call_intelligence_close.svg?url"
import PhoneOutgoingIcon from "./default/call_intelligence_phone-outgoing.svg?url"
import LogoIcon from "./default/call_intelligence_logo.svg?url"
import StarIcon from "./default/call_intelligence_stars.svg?url"
import IconChevronLeft from "./default/chevron-left.svg?url"
import IconChevronRight from "./default/chevron-right.svg?url"
import CallIntelligenceIcon from "./default/call_intelligence.svg?url"
import CallIntelligenceUnavailable from "./default/call_intelligence_unavailable.svg?url"
import CallIntelligenceAIAvatar from "./default/call_intelligence_AI_avatar.svg?url"

import PropstreamCallIntelligenceAIAvatar from "./propstream/call_intelligence_AI_avatar.svg?url"
import PropstreamLogoIcon from "./propstream/call_intelligence_logo.svg?url"
import PropstreamIconBath from "./propstream/icon-bath.svg?url"
import PropstreamIconBed from "./propstream/icon-bed.svg?url"
import PropstreamIconLotSize from "./propstream/icon-lot-size.svg?url"
import PropstreamIconSQFT from "./propstream/icon-sqft.svg?url"

import defaultStyle from "./theme_default.css?inline"
import propstreamStyle from "./theme_propstream.css?inline"

const defaultImages = {
    IconBed,
    IconBath,
    IconLotSize,
    IconSQFT,
    DialerCloseAIIcon,
    PhoneOutgoingIcon,
    LogoIcon,
    StarIcon,
    IconChevronLeft,
    IconChevronRight,
    CallIntelligenceIcon,
    CallIntelligenceUnavailable,
    CallIntelligenceAIAvatar,
}

export default WrappedComponent =>
    memo(props => {
        const { theme, addStyle } = useContext(ThemeContext)
        const [images, setImages] = useState({})

        useEffect(() => {
            switch (theme) {
                case "propstream":
                    addStyle("call-intelligence-default", defaultStyle)
                    addStyle("call-intelligence-propstream", propstreamStyle)
                    setImages({
                        ...defaultImages,
                        CallIntelligenceAIAvatar: PropstreamCallIntelligenceAIAvatar,
                        LogoIcon: PropstreamLogoIcon,
                        IconBed: PropstreamIconBed,
                        IconBath: PropstreamIconBath,
                        IconLotSize: PropstreamIconLotSize,
                        IconSQFT: PropstreamIconSQFT,
                    })
                    break

                default:
                    addStyle("call-intelligence-default", defaultStyle)
                    setImages(defaultImages)
            }
        }, [])
        return <WrappedComponent {...props} images={images} theme={theme} />
    })
